import { render, staticRenderFns } from "./IssueRegisterDetail.vue?vue&type=template&id=dfd9c80a&"
import script from "./IssueRegisterDetail.vue?vue&type=script&lang=js&"
export * from "./IssueRegisterDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports